module.exports = __webpack_public_path__ + "img/23ED.fb8b39bf.svg";